type RecorderStatus = "error" | "idle" | "recorded" | "recording";

export interface RecorderState {
  error: Error | null;
  mimeType: string | null;
  recordedBlob: Blob | null;
  recordedUrl: string | null;
  status: RecorderStatus;
}

export type RecorderAction =
  | { type: "RECORDING_STARTED"; mimeType: string | null }
  | { type: "RECORDING_STOPPED"; blob: Blob; url: string }
  | { type: "RECORDING_ERROR"; error: Error }
  | { type: "RECORDING_CLEARED" };

export const initialState: RecorderState = {
  error: null,
  mimeType: null,
  recordedBlob: null,
  recordedUrl: null,
  status: "idle",
};

export const recorderReducer = (
  state: RecorderState,
  action: RecorderAction,
): RecorderState => {
  switch (action.type) {
    case "RECORDING_STARTED":
      return {
        ...state,
        error: null,
        mimeType: action.mimeType,
        recordedBlob: null,
        recordedUrl: null,
        status: "recording",
      };
    case "RECORDING_STOPPED":
      return {
        ...state,
        recordedBlob: action.blob,
        recordedUrl: action.url,
        status: "recorded",
      };
    case "RECORDING_ERROR":
      return {
        ...state,
        error: action.error,
        status: "error",
      };
    case "RECORDING_CLEARED":
      return initialState;
    default:
      return state;
  }
};
